import * as React from 'react'
import styled from 'styled-components'
import { Devices } from '@styles'

interface VideoPreviewProps {
  url: string
  title: string
  date: Date
  isSelected: boolean
  videoTitleLength: number
  onClick: () => void
}

export const VideoPreview = (props: VideoPreviewProps) => {
  const videoId = youtubeParser(props.url)
  const previewUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`

  const title =
    props.title.length >= props.videoTitleLength ? `${props.title.slice(0, props.videoTitleLength)}...` : props.title

  return (
    <Preview data-selected={props.isSelected}>
      <PreviewImage src={previewUrl} alt={props.title} onClick={props.onClick} />
      <Caption>
        <Title onClick={props.onClick}>{title}</Title>
        <Date>{props.date.toLocaleDateString()}</Date>
      </Caption>
    </Preview>
  )
}

const Title = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;

  margin-bottom: 15px;

  cursor: pointer;
`

const Date = styled.span`
  font-size: 14px;
  line-height: 16px;

  color: #828282;
`

const Caption = styled.figcaption`
  display: flex;
  flex-direction: column;

  padding: 13px 15px;
`

const PreviewImage = styled.img`
  display: flex;
  width: 100%;
  cursor: pointer;

  @media screen and ${Devices.desktopS} {
    width: 270px;
    height: 150px;
  }
`

const Preview = styled.figure`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  @media screen and ${Devices.desktopS} {
    display: flex;
    flex-direction: row;
    align-content: flex-start;

    width: 540px;
  }

  &[data-selected="true"] {
    background-color: rgba(228, 105, 209, 0.1);

    ${PreviewImage} {
      cursor: unset;
    }

    ${Title} {
      cursor: unset;
    }
  }
}
`

function youtubeParser(url: string) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[7].length === 11 ? match[7] : false
}
